module.exports = __webpack_public_path__ + "static/media/signage-industrial-img22.0bd134c1.jpg";